// © Microsoft Corporation. All rights reserved.
/**
 * Converts the given error object to its string representation based on
 * the type of the input object.
 * @param error - the error object to convert to a string.
 * @param tryIncludeErrorStack - If true, will try to get the stack of the error
 *  if the error is an actual Error object that has a stack.
 * @returns {string} - The string representation of the error.
 */
export function stringifyError(error, tryIncludeErrorStack) {
    if (error instanceof Error) {
        const message = error.toString();
        return tryIncludeErrorStack && error.stack
            ? `${message}, Stack: ${error.stack}`
            : message;
    }
    else if (typeof error === "string") {
        return error;
    }
    else {
        return tryStringifyJson(error);
    }
}
/**
 * Attempts to stringify json. Empty string in case of serialization error.
 * @param value - the JS value to convert to a string.
 * @returns {string} - Stringify'ed object
 */
export function tryStringifyJson(value) {
    // JSON.stringify returns `undefined` if `undefined` is passed
    // unlike how it handles `null` which is correctly converted to "null".
    // So we explicitly handle the undefined scenario here.
    if (value === undefined) {
        return "undefined";
    }
    try {
        return JSON.stringify(value);
    }
    catch {
        return "[serialization-error]";
    }
}
/**
 * Convert the given error "value" to an Error object.
 * It will retain the original error message if given an actual Error object
 * or otherwise the string representation of the input value will be used to create a new Error object.
 * @param error - The unknown error value to convert to an Error object.
 * @returns {Error} - The Error object created from the input value.
 */
export function toErrorObj(error) {
    return error instanceof Error
        ? error
        : new Error(stringifyError(error));
}
//# sourceMappingURL=ErrorHelper.js.map